import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import {
  esPostFechaLimite,
  getIsChangingEmpresa,
  LeyAntifraudeConfiguracionRequerida,
} from "feature-based/features/verifactu/organisms"
import { setShowValidarEmpresaModal } from "features/User/redux/slices/empresaSlice"
import { userSelector } from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback, useMemo } from "react"
import { Redirect, Route, Switch, useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { privateRoutes } from "./paths"

const PrivateRouteList = () => {
  const dispatch = useDispatch()
  const {
    location: { pathname },
  } = useHistory()
  const {
    activeCompany: { nif, verificada },
    activeCompanyIsLoading,
  } = useUsuarioEmpresaActiva()
  const { invitado } = useSelector(userSelector)

  const {
    EMPRESA,
    MIS_EMPRESAS,
    PROFILE,
    IMPORTAR_FACTURAS_OCR,
    REVISION_FACTURA_OCR,
    FACTURAS,
  } = ROUTES

  const redefineRoutes = useCallback(() => {
    if (!nif && !activeCompanyIsLoading) {
      return {
        routes: privateRoutes.filter(({ path }) =>
          [MIS_EMPRESAS, PROFILE].includes(path)
        ),
        redirectTo: ROUTES.MIS_EMPRESAS,
      }
    }

    if (!verificada && !activeCompanyIsLoading) {
      return {
        routes: privateRoutes.filter(
          ({ path }) =>
            path.includes(ROUTES.VALIDACIONES_DOCUMENTOS) ||
            path.includes(IMPORTAR_FACTURAS_OCR) ||
            [
              ...[EMPRESA, MIS_EMPRESAS, PROFILE],
              ...(invitado
                ? [IMPORTAR_FACTURAS_OCR, REVISION_FACTURA_OCR()]
                : []),
            ].includes(path)
        ),
        redirectTo: EMPRESA,
      }
    }

    return { routes: privateRoutes, redirectTo: FACTURAS }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitado, verificada, nif])

  const includesPathX = redefineRoutes().routes?.find((route) =>
    pathname.includes(route.path)
  )
  const isEmpresaRoute = redefineRoutes().redirectTo === ROUTES.EMPRESA
  const onRenderRedirect = useMemo(() => {
    if (!includesPathX && isEmpresaRoute) {
      dispatch(setShowValidarEmpresaModal())
    }

    return <Redirect to={redefineRoutes().redirectTo} />
  }, [includesPathX, isEmpresaRoute, redefineRoutes, dispatch])

  const isChangingEmpresa = getIsChangingEmpresa()
  const esDespuesDeFechaLimite = esPostFechaLimite()

  return (
    <>
      {!isChangingEmpresa &&
        !activeCompanyIsLoading &&
        !esDespuesDeFechaLimite && <LeyAntifraudeConfiguracionRequerida />}
      <Switch>
        {redefineRoutes().routes?.map((route) => {
          return (
            <Route
              // @ts-expect-error TS(2322): Type '{ exact: boolean | undefined; key: string; p...
              exact={route.exact}
              key={route.key}
              path={route.path}
              component={route.component}
            />
          )
        })}

        {onRenderRedirect}
      </Switch>
    </>
  )
}

export default PrivateRouteList
